module.exports = __webpack_public_path__ + "img/branding-logo.cfe00a32.svg";